// src/pages/Settings.js
import React, { useCallback, useEffect, useState } from "react";
import { Container, Paper } from "@mui/material";
import NotificationSnackbar from "../components/ui/NotificationSnackbar";

import SettingsForm from "../components/settings/SettingsForm";
import { GLOBAL_DEFAULTS } from "../components/settings/settingsFormUtils";
import { getSettings, updateSettings } from "../services/settingsService";
import { useSettings } from "../context/SettingsContext";

export default function Settings({ embedded = false }) {
  const { reloadSettings } = useSettings();
  const [settings, setSettings] = useState(null);

  const [notif, setNotif] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showNotif = useCallback((message, severity = "success") => {
    setNotif({ open: true, message, severity });
  }, []);

  const loadSettings = useCallback(async () => {
    try {
      const data = await getSettings();

      setSettings({
        ...data,
        currency_code: data.currency_code || GLOBAL_DEFAULTS.currencyCode || "",
        date_format: data.date_format || GLOBAL_DEFAULTS.dateFormat || "",
        gst_pricing_mode: String(data.gst_pricing_mode || 'EXCLUSIVE').toUpperCase(),
      });

    } catch (err) {
      console.error("❌ Failed to load settings", err);
      showNotif("Failed to load settings", "error");
    }
  }, [showNotif]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const handleSubmit = async (form) => {
    const formData = new FormData();
    formData.append("currency_code", form.currency_code || GLOBAL_DEFAULTS.currencyCode || "");
    formData.append("date_format", form.date_format || GLOBAL_DEFAULTS.dateFormat || "");
    formData.append("gst_pricing_mode", String(form.gst_pricing_mode || 'EXCLUSIVE').toUpperCase());

    try {
      await updateSettings(formData);
      showNotif("Preferences updated successfully!", "success");
      await Promise.all([loadSettings(), reloadSettings()]);
    } catch (err) {
      console.error("❌ Failed to update settings:", err);
      showNotif(err?.response?.data?.error || "Failed to update preferences", "error");
    }
  };

  if (!settings) return null;

  const formContent = <SettingsForm settings={settings} onSubmit={handleSubmit} />;
  return (
    <>
      {embedded ? formContent : <Container><Paper sx={{ p: 3 }}>{formContent}</Paper></Container>}

      <NotificationSnackbar
        open={notif.open}
        message={notif.message}
        severity={notif.severity}
        onClose={() => setNotif((p) => ({ ...p, open: false }))}
      />
    </>
  );
}
